import api from '@/helpers/fetch'

export default {
	state: {
		deadlines: null,
		deadlinesByDay: initDeadlinesByDay(),
		selectedDeadlineId: null,
		selectedDeadlineType: null,
		deadlinesByid: {},
		responsibleById: {},
		responsibleCostsById: {},
		responsibleByIdArray: [],
		responsibleCostsByIdArray: [],
		responsibleId: null,
		responsibleCostsId: null,
		totalNumber: 0,
		totalProvidencesNumber: 0,
		totalNumberInRange: 0,
		totalProvidencesInRange: 0,
		filteredCnj: null,
		fields: null,
		selectedTrial: null,
	},
	mutations: {
		SET_RESPONSIBLE_COSTS_ID(state, responsibleCostsId) {
			state.filteredCnj = null
			state.responsibleId = null
			state.responsibleCostsId = responsibleCostsId
		},
		SET_RESPONSIBLE_ID(state, responsibleId) {
			state.filteredCnj = null
			state.responsibleCostsId = null
			state.responsibleId = responsibleId
		},
		SET_FIELDS(state, fields) {
			let newFields = fields
			if (newFields && newFields.length) {
				newFields.splice(28, 0, 'Adicionar andamento')
			}
			state.fields = newFields
		},
		SET_FILTERED_CNJ(state, cnj) {
			state.responsibleId = null
			state.filteredCnj = cnj.replace(/\./g, '').replace(/-/g, '')
		},
		ADD_DEADLINES(state, deadlines) {
			state.deadlines = deadlines
		},
		PROCESS_DEADLINES(state) {
			processDeadlines(state)
		},
		SET_SELECTED_DEADLINE_ID(state, id) {
			state.selectedDeadlineId = id
		},
		SET_SELECTED_DEADLINE_TYPE(state, type) {
			state.selectedDeadlineType = type
		},
		SET_SELECTED_TRIAL(state, trial) {
			state.selectedTrial = trial
		},
	},
	actions: {
		triggerDeadlines: async function (context): Promise<void> {
			context.commit('PROCESS_DEADLINES')
		},
		fetchDeadlines: async function (context, options): Promise<void> {
			const res = await api.get(
				`/api/deadlines/${options.selectedDeadlineType}/${options.status}/${options.costsStatus}/${options.pendency}`,
			)

			const deadlines = res?.data
			const fields = res?.fields

			context.commit('ADD_DEADLINES', deadlines)
			context.commit('SET_FIELDS', fields)
			context.commit('PROCESS_DEADLINES')
		},
		fetchMyDeadlines: async function (context, options): Promise<void> {
			const res = await api.get(`/api/my-account/tasks/deadlines`)

			const deadlines = res?.data
			const fields = res?.fields

			context.commit('ADD_DEADLINES', deadlines)
			context.commit('SET_FIELDS', fields)
			context.commit('PROCESS_DEADLINES')
		},
		saveDeadline: async function (context, deadline): Promise<void> {
			const res = await api.put('/api/deadlines', deadline)
			return res
		},
		createDeadline: async function (context): Promise<void> {
			const res = await api.post('/api/deadlines', {})
			return res
		},
		selectDeadlineId: async function (context, id): Promise<void> {
			context.commit('SET_SELECTED_DEADLINE_ID', id)
		},
		selectDeadlineType: async function (context, type): Promise<void> {
			context.commit('SET_SELECTED_DEADLINE_TYPE', type)
		},
		filterDeadlines: async function (
			context,
			responsibleId,
		): Promise<void> {
			context.commit('SET_RESPONSIBLE_ID', responsibleId)
		},
		filterDeadlinesByCosts: async function (
			context,
			responsibleCostsId,
		): Promise<void> {
			context.commit('SET_RESPONSIBLE_COSTS_ID', responsibleCostsId)
		},
		filterDeadlinesByCnj: async function (context, cnj): Promise<void> {
			context.commit('SET_FILTERED_CNJ', cnj)
		},
		setSelectedTrial: function (context, trial) {
			context.commit('SET_SELECTED_TRIAL', trial)
		},
	},
}

function initDeadlinesByDay() {
	return {
		internal: {},
		fatal: {},
		realFatal: {},
	}
}

function processDeadlines(state) {
	const deadlines = state.deadlines
	state.deadlinesByDay = initDeadlinesByDay()

	state.deadlinesByid = {}
	state.totalNumber = 0 // prazos
	state.totalProvidencesNumber = 0 // providencias

	state.totalNumberInRange = 0 // prazos dentro do intervalo
	state.totalProvidencesInRange = 0 // providencias dentro do intervalo

	let nextFriday = new Date()
	let weekDay = nextFriday.getDay()

	const dayMilliseconds = 24 * 60 * 60 * 1000

	while (weekDay !== 5) {
		nextFriday = new Date(nextFriday.getTime() + dayMilliseconds)
		weekDay = nextFriday.getDay()
	}

	deadlines.forEach((deadline) => {
		deadline.system = deadline.system || {}

		const keys = Object.keys(state.deadlinesByDay)

		state.deadlinesByid[deadline.id] = deadline

		const responsible = deadline?.responsible
		if (responsible) {
			state.responsibleById[responsible.id] =
				state.responsibleById[responsible.id] || responsible
		}

		const responsibleCosts = deadline?.responsibleCosts
		if (responsibleCosts) {
			state.responsibleCostsById[responsibleCosts.id] =
				state.responsibleCostsById[responsibleCosts.id] ||
				responsibleCosts
		}

		const forEachCallback = (key) => {
			const date = deadline[key + 'Date']

			const map = state.deadlinesByDay[key]

			map[date] = map[date] || []
			map[date].push(deadline)
		}

		if (state.responsibleId) {
			if (responsible?.id === state.responsibleId) {
				keys.forEach(forEachCallback)

				state.totalNumber += 1
				if (deadline.providences) {
					state.totalProvidencesNumber += deadline.providences.length
				}
			}
		} else if (state.responsibleCostsId) {
			if (responsibleCosts?.id === state.responsibleCostsId) {
				keys.forEach(forEachCallback)

				state.totalNumber += 1
				if (deadline.providences) {
					state.totalProvidencesNumber += deadline.providences.length
				}
			}
		} else if (state.filteredCnj) {
			const cnj = deadline?.trial?.cnj
			if (cnj && cnj.includes && cnj.includes(state.filteredCnj)) {
				keys.forEach(forEachCallback)

				state.totalNumber += 1
				if (deadline.providences) {
					state.totalProvidencesNumber += deadline.providences.length
				}
			}
		} else {
			keys.forEach(forEachCallback)

			state.totalNumber += 1
			if (deadline.providences) {
				state.totalProvidencesNumber += deadline.providences.length
			}
		}

		const selectedDate = new Date(
			deadline[state.selectedDeadlineType + 'Date'],
		)

		if (deadline.status !== 'Protocolado' && selectedDate <= nextFriday) {
			state.totalNumberInRange += 1
			state.totalProvidencesInRange += deadline?.providences?.length || 0
		}
	})

	state.responsibleByIdArray = Object.keys(state.responsibleById)
	state.responsibleCostsByIdArray = Object.keys(state.responsibleCostsById)
}
